<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="payments_to_show"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.updated_at.split(".")[0] }}</td>
        <td class="text-xs-center">{{ $t(`payments.platform.${props.item.platform_app_name}`) }}</td>
        <td class="text-xs-center">{{ props.item.payment_type }}</td>
        <td class="text-xs-center">{{ props.item.payment_id }}</td>
        <td class="text-xs-center">{{ props.item.traceability_code }}</td>
        <td class="text-xs-center">{{ $t(`enrollments.payment_status.${props.item.payment_state}`) }}</td>
        <td class="text-xs-center">{{ props.item.payment_currency }} {{formatNumber(props.item.platform_payment_total)}}</td>
        <td class="text-xs-center">
          <v-btn
            v-if="props.item.platform_app_name !== 'ENROLLMENTS_YEARLY'"
            color="primary"
            small
            @click="downloadPaymentProof(props.item.id, props.item.platform_app_name, props.item.rowid_docto)"
            :loading="props.item.id === loading"
            :disabled="props.item.id === loading"
          >Comprobante</v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'payment-history-view',
    data() {
      return {
        headers: [
          {
            text: 'Fecha y hora ',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Plataforma',
            align: 'center',
            sortable: false,
            value: 'platform'
          },
          { text: 'Tipo pago', value: 'payment_id', align: 'center', },
          { text: 'Referencia', value: 'payment_id', align: 'center', },
          { text: 'Autorización/CUS', value: 'ticket_id', align: 'center', },
          { text: 'Estado', value: 'payment_status', align: 'center', },
          { text: 'Valor', value: 'total', align: 'center', },
          { text: 'Acciones', value: 'total', align: 'center', },
        ],
        payments: [],
        loading: 0,
      }
    },
    created () {
      this.init();
    },
    computed: {
      payments_to_show() {
        return this.payments.filter(payment => payment.traceability_code)
      }
    },
    methods: {
      init() {
        axios.get('/api/user/payments')
          .then(response => {
            if (response.status === 200) {
              this.payments = response.data.payments
            }
          })
          .catch(error => console.log(error))
      },
      formatNumber(number) {
        if(typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      downloadPaymentProof(payment_id, app_name, rowid_docto = null) {
        this.loading = payment_id
        let url = `/user/payment/proof/${payment_id}`
        if (app_name === "PENSIONS") {
          url = `/user/payment/proof/${rowid_docto}/${app_name}`
        }
        axios({
            url,
            method: 'GET',
            responseType: 'blob'
          })
          .then(resp => {
            if (resp.status === 200) {

              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(new Blob([resp.data]));
              link.setAttribute('download', `comprobante.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.loading = 0;
            }
          })
          .catch(error => {
            this.loading = 0;
            if (error.response.status === 404) {
              this.$store.dispatch('responseMessage', {
                  type: 'info',
                  text: 'Este servicio se ha pagado correctamente, pero el pago no ha sido generado en el sistema contable o bien la relación de este pago no existe en nuestro sistema. Por favor contacte el área de soporte',
                  title: 'Información',
                  modal: true
                })
            }
            console.log(error)
          })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/payment/history.vue